export default {
  valida_cpf_cnpj(valor) {
    const limpo = valor.replace(/\D/g, '');

    if (limpo.length === 11) {
      return this.validaCpf(limpo);
    } else if (limpo.length === 14) {
      return this.validaCnpj(limpo);
    } else {
      return false;
    }
  },

  validaCpf(cpf) {
    if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) return false;

    let soma = 0;
    for (let i = 0; i < 9; i++) {
      soma += parseInt(cpf.charAt(i)) * (10 - i);
    }
    let resto = 11 - (soma % 11);
    if (resto === 10 || resto === 11) resto = 0;
    if (resto !== parseInt(cpf.charAt(9))) return false;

    soma = 0;
    for (let i = 0; i < 10; i++) {
      soma += parseInt(cpf.charAt(i)) * (11 - i);
    }
    resto = 11 - (soma % 11);
    if (resto === 10 || resto === 11) resto = 0;
    return resto === parseInt(cpf.charAt(10));
  },

  validaCnpj(cnpj) {
    if (cnpj.length !== 14 || /^(\d)\1{13}$/.test(cnpj)) return false;

    const pesos = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    let soma = 0;
    for (let i = 0; i < 12; i++) {
      soma += parseInt(cnpj.charAt(i)) * pesos[i + 1];
    }
    let resto = soma % 11;
    resto = resto < 2 ? 0 : 11 - resto;
    if (resto !== parseInt(cnpj.charAt(12))) return false;

    soma = 0;
    for (let i = 0; i < 13; i++) {
      soma += parseInt(cnpj.charAt(i)) * pesos[i];
    }
    resto = soma % 11;
    resto = resto < 2 ? 0 : 11 - resto;
    return resto === parseInt(cnpj.charAt(13));
  },
};
